import { HttpClient, HttpBackend } from '@angular/common/http';
import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
const TRANSLATE_HTTP_LOADER_CONFIG = new InjectionToken("TRANSLATE_HTTP_LOADER_CONFIG");
let TranslateHttpLoader = /*#__PURE__*/(() => {
  class TranslateHttpLoader {
    http;
    config;
    constructor() {
      this.config = {
        prefix: "/assets/i18n/",
        suffix: ".json",
        enforceLoading: false,
        useHttpBackend: false,
        ...inject(TRANSLATE_HTTP_LOADER_CONFIG)
      };
      this.http = this.config.useHttpBackend ? new HttpClient(inject(HttpBackend)) : inject(HttpClient);
    }
    /**
     * Gets the translations from the server
     */
    getTranslation(lang) {
      const cacheBuster = this.config.enforceLoading ? `?enforceLoading=${Date.now()}` : "";
      return this.http.get(`${this.config.prefix}${lang}${this.config.suffix}${cacheBuster}`);
    }
    static ɵfac = function TranslateHttpLoader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TranslateHttpLoader)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TranslateHttpLoader,
      factory: TranslateHttpLoader.ɵfac
    });
  }
  return TranslateHttpLoader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideTranslateHttpLoader(config = {}) {
  const useBackend = config.useHttpBackend ?? false;
  return [{
    provide: TRANSLATE_HTTP_LOADER_CONFIG,
    useValue: config
  }, {
    provide: TranslateLoader,
    useClass: TranslateHttpLoader,
    deps: [useBackend ? HttpBackend : HttpClient, TRANSLATE_HTTP_LOADER_CONFIG]
  }];
}

/**
 * Generated bundle index. Do not edit.
 */

export { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader, provideTranslateHttpLoader };
